<template>
  <router-link :to="link" class="list-box-item" :class="{ notify: unread }" v-if="link">
    <div class="image-circle">
      <img :src="userData.profileimg">
    </div>
    <p class="nano">{{ message }}<span>{{ dateShow }}</span></p>
  </router-link>
  <div class="list-box-item" :class="{ notify: unread }" v-else>
    <div class="image-circle">
      <img :src="userData.profileimg">
    </div>
    <p class="nano">{{ message }}<span>{{ dateShow }}</span></p>
  </div>
</template>

<script>
import { db } from '@/firebase'
import moment from 'moment'

export default {
  props: ['senderid', 'message', 'when', 'unread', 'link'],
  firebase: function () {
    return {
      userData: {
        source: db.ref('users/' + this.senderid),
        asObject: true
      }
    }
  },
  computed: {
    dateShow: function () {
      let date = moment(this.when).fromNow()
      return date
    }
  }
}
</script>



// WEBPACK FOOTER //
// NotificationItem.vue?8dddd794